export default __webpack_public_path__ + "static/media/image3.f5112820.png";